/**
 * Кастомная иконка «Скрыть» — глаз с перечёркиванием
 *
 * fill="currentColor" для окрашивания через Tailwind
 * Совместима с IconComponent (принимает size, style, className)
 */

import type { CSSProperties } from 'react';

interface IconProps {
  className?: string;
  size?: number | string;
  style?: CSSProperties;
}

export function HideIcon({ className, size, style }: IconProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5743 6.61865L16.321 10.9852C16.3774 11.2864 16.4112 11.5875 16.4112 11.9002C16.4112 14.402 14.4256 16.429 12 16.429C11.6954 16.429 11.402 16.3942 11.1087 16.3363H11.0974L7.50977 20.0196C8.87489 20.5871 10.3979 20.9346 12 20.9346C18.0923 20.9346 22.9999 16.0004 22.9999 11.9002C22.9999 10.1397 22.0861 8.22862 20.5743 6.61865Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.58869 11.9001C7.58869 9.39825 9.56304 7.37138 11.9999 7.37138C12.8574 7.37138 13.6697 7.62619 14.3466 8.07791L13.1056 9.35193C12.7671 9.18977 12.3948 9.10869 11.9999 9.10869C10.4994 9.10869 9.28099 10.3596 9.28099 11.9001C9.28099 12.3055 9.35996 12.6877 9.51791 13.0352L8.26561 14.3208C7.83689 13.6259 7.58869 12.7919 7.58869 11.9001ZM10.6574 14.3324L14.3692 10.5333L15.5876 9.27085L19.3107 5.46027L19.2994 5.44869L21.2173 3.47966C21.5558 3.14377 21.5558 2.58781 21.2173 2.25192C20.8902 1.91603 20.3486 1.91603 20.0215 2.25192L17.8553 4.47576C16.163 3.49125 14.1548 2.86579 11.9999 2.86579C5.90767 2.86579 1 7.81151 1 11.9001C1 14.0428 2.34256 16.4172 4.49742 18.1894L2.22974 20.5174C1.89128 20.8649 1.89128 21.4093 2.22974 21.7452C2.38769 21.9189 2.61333 22 2.82768 22C3.04204 22 3.2564 21.9189 3.42563 21.7452L4.6328 20.5174L5.90767 19.197H5.91895L10.6574 14.3324Z"
        fill="currentColor"
      />
    </svg>
  );
}